import { render, staticRenderFns } from "./AddEmployeeTaxDetailComponent.vue?vue&type=template&id=0f2b10e6&"
import script from "./AddEmployeeTaxDetailComponent.vue?vue&type=script&lang=js&"
export * from "./AddEmployeeTaxDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports